module.exports = __webpack_public_path__ + "img/ic_ongoing.3acd439b.svg";